import _ from "lodash";
import { equipmentsListName, linesListName } from "src/api/config";

export function getObjectDiff(obj1: any, obj2: any) {
  let allkeys = _.union(_.keys(obj1), _.keys(obj2));
  let difference = _.reduce(
    allkeys,
    function (result: any, key) {
      if (!_.isEqual(obj1[key], obj2[key])) {
        result[key] = { new: obj1[key], old: obj2[key] };
      }
      return result;
    },
    {}
  );
  return difference;
}

export const dataFormForSharepoint = (data: any) => {
  const sendData: any = {};
  Object.keys(data).map((key) => {
    if (key === "Code") {
      let code = "",
        index = "";
      const codeArr = data[key]["new"].split(".");
      index = codeArr[codeArr.length - 1];
      code = data[key]["new"].slice(0, -(index.length + 1));
      sendData["Code"] = code;
      sendData["Index"] = index;
    }
    if (key === "Path") {
      sendData["Path"] = data[key]["new"];
    }
    if (key === "Title") {
      sendData["Title"] = data[key]["new"];
    }
    if (key === "Collection") {
      sendData["Collection"] = data[key]["new"]["id"];
    }
    if (key === "Department") {
      sendData["Department"] = data[key]["new"]["id"];
    }
    if (key === "Sector") {
      sendData["Sector"] = data[key]["new"]["id"];
    }
    if (key === "Process") {
      sendData["Process"] = data[key]["new"]["id"];
    }
    if (key === "DocType") {
      sendData["DocType"] = data[key]["new"]["id"];
    }
    if (key === "ResponsibleForRevision") {
      sendData["ResponsibleForRevision"] = data[key]["new"][0]["value"];
      sendData["ResponsibleForRevisionEmail"] =
        data[key]["new"][0]["value"].toLowerCase();
    }
    if (key === "DateForRevision") {
      sendData["DateForRevision"] =
        (typeof data[key]["new"]["startDate"] === "string" &&
          new Date(data[key]["new"]["startDate"])) ||
        data[key]["new"]["startDate"];
    }
    if (key === "Critical") {
      sendData["Critical"] = data[key]["new"]["id"];
    }
    if (key === "WorkPlaces") {
      sendData["WorkPlaces"] =
        data[key]["new"] &&
        Array.isArray(data[key]["new"]) &&
        data[key]["new"].length > 0 &&
        data[key]["new"].map((place) => place.id) || null;
    }
    if (key === "File") {
      sendData["File"] = data[key]["new"][0];
    }
  });
  if (data.Equipments && data.Equipments["new"].length > 0) {
    let linesStrIds = "",
      equipmentsStrIds = "";
    for (let i = 0; i < data.Equipments["new"].length; i++) {
      if (data.Equipments["new"][i]["Line"]) {
        linesStrIds += `${data.Equipments["new"][i]["Line"]["id"]},`;
      }
      if (data.Equipments["new"][i]["SAP"]) {
        equipmentsStrIds += `${data.Equipments["new"][i]["SAP"]["ID"]},`;
      }
    }
    sendData[linesListName] = (linesStrIds && linesStrIds.slice(0, -1)) || "";
    sendData[equipmentsListName] =
      (equipmentsStrIds && equipmentsStrIds.slice(0, -1)) || "";
    sendData["EquipmentsListNew"] = data[equipmentsListName]["new"];
    sendData["EquipmentsListOld"] = data[equipmentsListName]["old"];
  }
  return sendData;
};
